<template>
    <div class="columns">
      <aside class="column is-offset-1 is-4-widescreen">
        <div class="box">
          <!-- <div class="field">
            <button 
            class="button is-rounded is-primary is-outlined is-fullwidth is-medium" 
            @click.prevent="quickAddMonster()">Quick Add Monster</button>
          </div> -->
          <form @submit.prevent="addMonster()">
            <div class="field">
              <p class="control has-icons-left">
                <input 
                v-model="monsterDetails.name" 
                placeholder="Name (optional)" 
                class="input is-rounded is-medium">
                <span class="icon is-left">
                  <i class="fas fa-user-circle"></i>
                </span>
              </p>
            </div>
            <div class="field">
              <p class="control has-icons-left">
                <input 
                v-model="monsterDetails.hitPoints" 
                type="number" 
                placeholder="Hit Points (optional)" 
                class="input is-rounded is-medium">
                <span class="icon is-left">
                  <i class="fas fa-heart"></i>
                </span>
              </p>
            </div>
            <div class="field has-text-left">
              <label class="checkbox">
                <input type="checkbox" v-model="manualInitiative">
                Manually enter initiative
              </label>
            </div>
            <div v-show="manualInitiative" class="field">
              <p class="control has-icons-left">
                <input 
                v-model="monsterDetails.initiative" 
                type="number" 
                placeholder="Initiative (optional)" 
                class="input is-rounded is-medium">
                <span class="icon is-left">
                  <i class="fas fa-dice-d20"></i>
                </span>
              </p>
            </div>
            <div class="field">
              <button 
              type="button"
              class="button is-rounded is-text is-fullwidth add-detail" 
              @click.prevent="toggleDetailAdd()">
                <span>Add More Details</span>
                <span class="icon is-small" 
                :class="{ 'is-open' : showMonsterForm }">
                  <i class="fas fa-angle-down"></i>
                </span>
              </button>
            </div>
            <div v-show="showMonsterForm" class="has-text-left">
              <div class="field">
                <label class="label" for="cr">Complete form using CR (optional):</label>
                <div class="control">
                  <p class="select is-rounded">
                    <select 
                    id="cr" 
                    v-model="monsterDetails.rating"
                    @change="randomizeMonsterDetails()">
                      <option value="" disabled>Challenge Rating</option>
                      <option v-for="item in crTable" :value="item.rating" :key="item.rating">{{ item.rating }}</option>
                    </select>
                  </p>
                </div>
              </div>
              <hr>
              <div class="field">
                <label class="label" for="prof">Proficiency Bonus (optional)</label>
                <p class="control has-icons-left">
                  <input 
                  id="prof"
                  v-model="monsterDetails.proficiency" 
                  type="number" 
                  class="input is-rounded is-medium">
                  <span class="icon is-left">
                    <i class="fas fa-plus"></i>
                  </span>
                </p>
              </div>
              <div class="field">
                <label class="label" for="ac">Armor Class (optional)</label>
                <p class="control has-icons-left">
                  <input 
                  id="ac"
                  v-model="monsterDetails.armorClass" 
                  type="number" 
                  class="input is-rounded is-medium">
                  <span class="icon is-left">
                    <i class="fas fa-shield-alt"></i>
                  </span>
                </p>
              </div>
              <div class="field">
                <label class="label" for="attack">Attack Bonus (optional)</label>
                <p class="control has-icons-left">
                  <input 
                  id="attack"
                  v-model="monsterDetails.attackBonus" 
                  type="number" 
                  class="input is-rounded is-medium">
                  <span class="icon is-left">
                    <i class="fas fa-fist-raised"></i>
                  </span>
                </p>
              </div>
              <div class="field">
                <label class="label" for="dmg">Damage/Round (optional)</label>
                <p class="control has-icons-left">
                  <input 
                  id="dmg"
                  v-model="monsterDetails.damagePerRound" 
                  type="number" 
                  class="input is-rounded is-medium">
                  <span class="icon is-left">
                    <i class="fas fa-tired"></i>
                  </span>
                </p>
              </div>
              <div class="field">
                <label class="label" for="save">Save DC (optional)</label>
                <p class="control has-icons-left">
                  <input 
                  id="save"
                  v-model="monsterDetails.saveDc" 
                  type="number" 
                  class="input is-rounded is-medium">
                  <span class="icon is-left">
                    <i class="fas fa-user-shield"></i>
                  </span>
                </p>
              </div>
              <span></span>
            </div>
            <div class="field">
              <p class="control">
                <button type="submit" class="button is-rounded is-info is-fullwidth is-medium">Add Monster</button>
              </p>
            </div>
            <div class="field">
              <p class="control">
                <button class="button is-rounded is-fullwidth is-outlined is-small" @click.prevent="clearForm()">Reset Form</button>
              </p>
            </div>
          </form>
          <div v-if="!!encounter.length">
            <hr>
            <div v-show="monsters.length"  class="field">
              <p class="control">
                <button class="button is-rounded is-warning is-fullwidth is-medium" @click.prevent="clearMonsters">Delete All Monsters</button>
              </p>
            </div>
            <div class="field">
              <p class="control">
                <button class="button is-rounded is-danger is-fullwidth is-medium is-outlined" @click.prevent="resetCampaign">Start New Encounter</button>
              </p>
            </div>
          </div>
        </div>
      </aside>
      <main class="column is-6">
        <article 
        v-for="entity in encounter" 
        class="party" 
        :class="[entity.type === 'monster' ? 'party--monster' : 'party--player']"
        :key="entity.id">
          <MonsterCard 
          v-if="entity.type === 'monster'" 
          :campaignId="id"
          :monsterId="entity.id"/>
          <PlayerCard 
          v-else 
          :campaignId="id"
          :member="entity"/>
        </article>
        <div v-if="!encounter.length">
          <p>Nothing in initiative order yet...</p>
        </div>
      </main>
    </div>
</template>
<script>
import store from '../store'
import { mapState } from 'vuex'
import { db } from '../main'
import MonsterCard from '../components/MonsterCard.vue'
import PlayerCard from '../components/PlayerCard.vue'

export default {
  name: 'CampaignDm',
  props: {
    id: String,
    name: String,
    slug: String
  },
  data () {
    return {
      party: [],
      monsters: [],
      damage: null,
      showMonsterForm: false,
      manualInitiative: false,
      monsterDetails: {
        name: null,
        hitPoints: null,
        initiative: null,
        rating: null,
        proficiency: null,
        armorClass: null,
        attackBonus: null,
        damagePerRound: null,
        saveDc: null,
        // abilities: {
        //   strength: null,
        //   dexterity: null,
        //   constitution: null,
        //   intelligence: null,
        //   wisdom: null,
        //   charisma: null,
        // },
      }
    }
  },
  firestore () {
    // return {
    //   campaign: db.collection('campaigns').doc(this.id)
    // }
    this.$bind('party', db.collection('campaigns').doc(this.id).collection('party'))
    this.$bind('monsters', db.collection('campaigns').doc(this.id).collection('monsters'))
  },
  computed: {
    ...mapState({
      nouns: state => state.randNouns, 
      adjectives: state => state.randAdjectives,
      synonyms: state => state.monsterSynonyms,
      crTable: state => state.crTable,
    }),
    // userId () {
    //   return this.user.uid
    // },
    encounter () {
      const list = [...this.party, ...this.monsters]
      return list.sort(function(a, b) {
        var numA = parseInt(a.initiative); // ignore upper and lowercase
        var numB = parseInt(b.initiative); // ignore upper and lowercase
        if (numA < numB) {
          return 1;
        }
        if (numA > numB) {
          return -1;
        }
        return 0;
      })
    }
  },
  methods: {
    toggleDetailAdd () {
      this.showMonsterForm = (this.showMonsterForm) ? false :true
    },
    addMonster () {
      const monster = {
        name: (this.monsterDetails.name) ? this.titleCase(this.monsterDetails.name) : this.randomName(),
        initiative: (this.monsterDetails.initiative) ? parseInt(this.monsterDetails.initiative) : this.rollDice(1, 20),
        type: 'monster',
        hp: (this.monsterDetails.hitPoints) ? parseInt(this.monsterDetails.hitPoints) : false,
        hpMax: (this.monsterDetails.hitPoints) ? parseInt(this.monsterDetails.hitPoints) : false,
        rating: this.monsterDetails.rating,
        proficiency: parseInt(this.monsterDetails.proficiency),
        armorClass: parseInt(this.monsterDetails.armorClass),
        attackBonus: parseInt(this.monsterDetails.attackBonus),
        damagePerRound: parseInt(this.monsterDetails.damagePerRound),
        saveDc: parseInt(this.monsterDetails.saveDc)
      }
      db.collection('campaigns')
        .doc(this.id)
        .collection('monsters')
        .add(monster)
        .then(() => {
          console.log('monster added!')
          // this.monsterDetails = {
          //   name: null,
          //   rating: null,
          //   proficiency: null,
          //   armorClass: null,
          //   hitPoints: null,
          //   attackBonus: null,
          //   damagePerRound: null,
          //   saveDc: null,
          // }
        })
    },
    randomName () {
      const adjective = this.adjectives[this.randomIndex(this.adjectives.length)]
      const noun = this.nouns[this.randomIndex(this.nouns.length)]
      const synonym = this.synonyms[this.randomIndex(this.synonyms.length)]
      const name = this.titleCase(`${adjective} ${noun} ${synonym}`)
      return name
    },
    // quickAddMonster () {
    //   const title = this.randomName()
    //   const number = this.rollDice(1, 20)
    //   const hitpoints = false
    //   const type = 'monster'
    //   this.addMonster(title, number, hitpoints, type)
    // },
    initiativeOrder (a, b) {
      // Use toUpperCase() to ignore character casing
      const numA = parseInt(a.initiative)
      const numB = parseInt(b.initiative)

      let comparison = 0;
      if (numA > numB) {
        comparison = 1
      } else if (numA < numB) {
        comparison = -1
      }
      return comparison
    },
    randomizeMonsterDetails () {
      if (!this.monsterDetails.name) {
        this.monsterDetails.name = this.randomName()
      }
      const cr = this.monsterDetails.rating
      const table = this.crTable.filter((item) => item.rating === cr)
      
      this.monsterDetails.proficiency = table[0].proficiency
      this.monsterDetails.armorClass = table[0].armorClass
      this.monsterDetails.attackBonus = table[0].attackBonus
      this.monsterDetails.saveDc = table[0].saveDc
      
      this.monsterDetails.hitPoints = this.rollDice(table[0].hpMinMax.min, table[0].hpMinMax.max)
      this.monsterDetails.damagePerRound = this.rollDice(table[0].damageMinMax.min, table[0].damageMinMax.max)
    },
    clearForm () {
      this.monsterDetails = {
        name: null,
        rating: null,
        proficiency: null,
        armorClass: null,
        hitPoints: null,
        attackBonus: null,
        damagePerRound: null,
        saveDc: null,
      }
      this.manualInitiative = false
    },
    clearMonsters () {
      this.monsters.forEach((monster) => {
        db.collection('campaigns')
          .doc(this.id)
          .collection('monsters')
          .doc(monster.id)
          .delete()
          .then(() => {
            console.log(`${monster.name} deleted!`)
          })
      })
    },
    resetCampaign () {
      this.clearMonsters()
      this.party.forEach(player => {
        db.collection('campaigns')
          .doc(this.id)
          .collection('party')
          .doc(player.id)
          .update({ 
            initiative: null
          })
          .then(() => {
            console.log(`${player.name} reset!`)
          })
      })
    },
  },
  components: {
    MonsterCard,
    PlayerCard,
  }
}
</script>
<style scoped>
.party {
  margin-bottom: 1.5em;
}
.party--player {
  margin-right: 15%;
}
.reset-campaign {
  padding: 0.75em 0;
}
.add-detail.is-text {
  text-decoration: none;
}
.add-detail .icon {
  transition: transform 0.2s ease;
}
.icon.is-open {
  transform: rotate(180deg);
}
@media screen and (min-width: 769px) {
  .column:first-child {
    order: 2;
  }
}
@media screen and (max-width: 768px) {
  .column {
    margin-bottom: 1.5em;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/CampaignDm.vue